import MailModuleWrapper from 'mini-mail-module-view/lib/components/MailModuleWrapper';
import OwaWorkload from 'owa-workloads/lib/store/schema/OwaWorkload';
import React from 'react';
import selectFolderWithFallback from './utils/selectFolderWithFallback';
import strings from 'owa-strings/owa-mini-strings';
import { BootstrapOptions } from 'mini-bootstrap';
import { getMiniAnalyticsOptions } from 'mini-app-analytics';
import { initializeMailModuleState } from './utils/initializeMailModuleState';
import { lazySetupMailFunctionalBoot } from 'mini-mail-post-boot';
import { mailRouterOptions } from './routing/mailRoutes';
import { miniIconsRegistration } from 'owa-mini-icons';
import { Module } from 'mini-common-schema';
import { SessionData } from 'owa-service/lib/types/SessionData';
import 'mini-mail-list-store';

export async function getMailBootstrapOptions(
    sessionPromise: Promise<SessionData | undefined>
): Promise<BootstrapOptions> {
    return {
        initializeState: initializeMailModuleState,
        sessionPromise,
        routerOptions: mailRouterOptions,
        workload: OwaWorkload.Mail,
        analyticsOptions: getMiniAnalyticsOptions(),
        iconFonts: [miniIconsRegistration],
        appModuleProps: {
            module: Module.Mail,
            renderModule: () => <MailModuleWrapper />,
            overrideFavIcon: 'resources/images/favicons/favicon-mail.ico',
            activeModuleAction: () => {
                selectFolderWithFallback(null);
            },
        },
        getModuleName: () => strings.mailModuleName,
        postLazyAction: lazySetupMailFunctionalBoot,
        shouldInitializeTimeZoneAnonymously: false,
    };
}
